module.exports = __webpack_public_path__ + "img/boom2.1e3e6127.jpg";